export enum NOTA_CREDITO_TYPES {
  NC_SET_VIEW = 'NC_SET_VIEW',
  NC_SET_FORM_CLIENTE = 'NC_SET_FORM_CLIENTE',
  NC_HANDLE_ERRORS_CLIENTE = 'NC_HANDLE_ERRORS_CLIENTE',
  NC_SET_FORM_PRODUCTO = 'NC_SET_FORM_PRODUCTO',
  NC_HANDLE_ERRORS_PRODUCTO = 'NC_HANDLE_ERRORS_PRODUCTO',
  NC_SET_PRODUCTOS = 'NC_SET_PRODUCTOS',
  NC_SET_PRODUCTO_EDIT = 'NC_SET_PRODUCTO_EDIT',
  NC_SET_PRODUCTO_INDEX = 'NC_SET_PRODUCTO_INDEX',

  NC_ACTIVE_MODAL_EDITAR_PRODUCTO = 'NC_ACTIVE_MODAL_EDITAR_PRODUCTO',
  NC_ACTIVE_MODAL_ELIMINAR_PRODUCTO = 'NC_ACTIVE_MODAL_ELIMINAR_PRODUCTO',
  NC_ACTIVE_MODAL_QUITAR_TODO = 'NC_ACTIVE_MODAL_QUITAR_TODO',
  NC_ACTIVE_MODAL_EMITIR = 'NC_ACTIVE_MODAL_EMITIR',
  NC_ACTIVE_MODAL_EMITIDO = 'NC_ACTIVE_MODAL_EMITIDO',
  NC_ACTIVE_MODAL_MAS_OPCIONES = 'NC_ACTIVE_MODAL_MAS_OPCIONES',
  NC_ACTIVE_MODAL_ENVIAR_CORREO = 'NC_ACTIVE_MODAL_ENVIAR_CORREO',
  NC_ACTIVE_MODAL_IMPRIMIR = 'NC_ACTIVE_MODAL_IMPRIMIR',
  NC_ACTIVE_MODAL_ANULAR = 'NC_ACTIVE_MODAL_ANULAR',
  NC_ACTIVE_MODAL_ANULADO = 'NC_ACTIVE_MODAL_ANULADO',

  NC_SET_QR_CODE = 'NC_SET_QR_CODE',
  NC_SET_TOTAL_ORIGINAL = 'NC_SET_TOTAL_ORIGINAL',
  NC_SET_RESPONSE_EMITIR = 'NC_SET_RESPONSE_EMITIR',

  NC_SET_CALCULOS_PRODUCTO = 'NC_SET_CALCULOS_PRODUCTO',
  NC_SET_CALCULOS_GENERALES = 'NC_SET_CALCULOS_GENERALES',

  NC_RESTART_FORM_PRODUCTO = 'NC_RESTART_FORM_PRODUCTO',
  NC_RESTART_ALL = 'NC_RESTART_ALL',
  NC_SET_CLIENTE_ENCONTRADO = 'NC_SET_CLIENTE_ENCONTRADO',
  NC_ACTIVE_MODAL_CLIENTE_ENCONTRADO = 'NC_ACTIVE_MODAL_CLIENTE_ENCONTRADO',
}
